import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class UserService {
    constructor(){

    }

    private localeString: string = 'sr-Latn';
    private dateFormat: string = 'dd.MM.yyyy';
    private numberFormat: string = '1.2-2';
    private dateTimeFormat: string = 'dd.MM.yyyy HH:mm';
    private booleanFormat: string = '<span class="fa fa-fw fa-check"></span>';
    private decimalSeparator: string = ',';
    private thousandSeparator: string = '.';
    private dateSeparator: string = '.';

    GetLocaleString(){
        return this.localeString;
    }

    GetDateFormat(){
        return this.dateFormat;
    }

    GetNumberFormat(){
        return this.numberFormat;
    }

    GetDateTimeFormat(){
        return this.dateTimeFormat;
    }

    GetBooleanFormat(){
        return this.booleanFormat;
    }

    GetUserRights(){
        return {
            'AllowEdit': false,
            'AllowDelete': false,
            'AllowPrint': false
        }
    }

    GetDecimalSeparator(){
        return this.decimalSeparator;
    }

    GetThousandSeparator(){
        return this.thousandSeparator;
    }

    GetDateSeparator(){
        return this.dateSeparator;
    }
}